import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Link } from "@mui/material";
import { getFiled } from "../../services/backend/CorrespondenceService";
import { useSelector } from "react-redux";

export default function RadicadoBacklink({ parentRadicadoId }) {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.value);
  const [parentRadicado, setParentRadicado] = useState(null);

  useEffect(() => {
    if (parentRadicadoId && user?.token) {
      (async () => {
        const data = await getFiled(user.token, parentRadicadoId);
        if (data) {
          setParentRadicado(data);
        }
      })();
    }
  }, [parentRadicadoId, user]);

  const handleClick = () => {
    if (parentRadicado?.referenceId) {
      navigate(`/filed/view/${parentRadicado.referenceId}`);
    }
  };

  if (!parentRadicadoId) return null;

  const displayName = parentRadicado?.filedId 
    ? `${parentRadicado.filedId}.pdf`
    : `Radicado #${parentRadicadoId}`;

  return (
    <Box
      sx={{
        p: { xs: 1.5, sm: 2 },
        mb: { xs: 1.5, sm: 2 },
        backgroundColor: "#f5f5f5",
        borderRadius: 1,
        border: "1px solid #e0e0e0",
      }}
    >
      <Typography 
        variant="body1" 
        sx={{ 
          fontSize: { xs: "0.875rem", sm: "1rem" },
          lineHeight: { xs: 1.5, sm: 1.75 }
        }}
      >
        Este radicado es una respuesta a →{" "}
        <Link
          component="button"
          variant="body1"
          onClick={handleClick}
          sx={{ 
            cursor: "pointer", 
            textDecoration: "underline",
            fontSize: { xs: "0.875rem", sm: "1rem" },
            wordBreak: "break-word",
            display: "inline"
          }}
        >
          {displayName}
        </Link>
      </Typography>
    </Box>
  );
}
